export default "__VITE_ASSET__BbPR2K6A__"